"use strict";module.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff";